export var LEDGER_COMM_ENTITY;
(function (LEDGER_COMM_ENTITY) {
    LEDGER_COMM_ENTITY["ECL"] = "ECL";
    LEDGER_COMM_ENTITY["EBL"] = "EBL";
})(LEDGER_COMM_ENTITY || (LEDGER_COMM_ENTITY = {}));
export var LEDGER_REPORT_TYPE;
(function (LEDGER_REPORT_TYPE) {
    LEDGER_REPORT_TYPE["DETAIL"] = "Detail";
    LEDGER_REPORT_TYPE["SNAPSHOT"] = "Snapshot";
})(LEDGER_REPORT_TYPE || (LEDGER_REPORT_TYPE = {}));
